import type { FunctionComponent, SVGProps } from 'react';
import Icon from './Icon';

const SmileBeam: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <Icon width="65px" height="65px" viewBox="0 0 65 65" {...props}>
    <path
      d="M22.016,33.869A4.9,4.9,0,0,1,26.144,36.7l1.245,2.228a1.038,1.038,0,0,0,1.219.485,1.05,1.05,0,0,0,.747-1.088c-.432-5.517-4.22-9.357-7.339-9.357s-6.906,3.84-7.339,9.357a1.06,1.06,0,0,0,.747,1.088,1.073,1.073,0,0,0,1.219-.485L17.888,36.7A4.877,4.877,0,0,1,22.016,33.869ZM32.5,8A32.5,32.5,0,1,0,65,40.5,32.494,32.494,0,0,0,32.5,8Zm0,60.806A28.306,28.306,0,1,1,60.806,40.5,28.339,28.339,0,0,1,32.5,68.806ZM42.984,28.968c-3.119,0-6.906,3.84-7.339,9.357a1.06,1.06,0,0,0,.747,1.088,1.073,1.073,0,0,0,1.219-.485L38.856,36.7a4.9,4.9,0,0,1,4.128-2.831A4.9,4.9,0,0,1,47.112,36.7l1.245,2.228a1.038,1.038,0,0,0,1.219.485,1.05,1.05,0,0,0,.747-1.088C49.89,32.807,46.1,28.968,42.984,28.968Zm1.337,20.679a15.4,15.4,0,0,1-23.641,0,2.093,2.093,0,1,0-3.211,2.686,19.574,19.574,0,0,0,30.076-.013,2.084,2.084,0,0,0-.262-2.949,2.113,2.113,0,0,0-2.962.275Z"
      transform="translate(0 -8)"
    />
  </Icon>
);

export default SmileBeam;
